// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oFo5","index":"styles_index__3UWt-"};